import { TertiaryTable } from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useGetEducatorsQuery } from "../../../../common/api/educator";
import { mapEmployeeCertificateDataToRows } from "../../utils/mapEmployeeCertificateDataToRows";
import { useParams } from "react-router";
import { getEducatorTableColumns } from "../../utils/getEducatorTableColumns";
import { JSX } from "react";

export const EmployeeQualificationDetailContent = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const qualificationId = Number(useParams().qualificationId);
    const { sortEducators } = useAppSelector(
        (state) => state.qualificationDetail,
    );

    const {
        data: educatorData,
        isLoading: educatorDataIsLoading,
        isFetching: educatorDataIsFetching,
    } = useGetEducatorsQuery({
        items_per_page: 9999,
        sort: sortEducators.sortName,
        filter: {
            qualification_id: qualificationId,
        },
    });

    return (
        <div className="p-qualification-detail__content">
            {educatorDataIsLoading || educatorDataIsFetching ? (
                <Skeleton
                    height={"30rem"}
                    borderRadius={"1.5rem"}
                    style={{ marginTop: "-12rem" }}
                />
            ) : (
                educatorData && (
                    <TertiaryTable
                        data={{
                            columns: getEducatorTableColumns({
                                sortEducators,
                                dispatch,
                            }),
                            rows: mapEmployeeCertificateDataToRows({
                                educatorData: educatorData.data,
                                dispatch,
                            }),
                            total: educatorData.meta.total,
                        }}
                        isDataEmpty={educatorData.meta.total === 0}
                        title={"Opleiders"}
                        emptyResultText={"Geen opleiders gevonden"}
                    />
                )
            )}
        </div>
    );
};
